import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { ErrorInterceptor } from 'app/core/auth/error.interceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
//import { ClickDoubleDirective } from 'app/core/directives/click-handler.directive';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { PipesModule } from '../pipes/pipes.module';
//import { AvgRatingsPipe } from 'app/core/pipes/avg-ratings.pipe';
//import { TaxiGenreParserPipe } from 'app/core/pipes/taxi_genre_parser.pipe';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatSnackBarModule,
        PipesModule,
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatSnackBarModule,
        PipesModule,
    ],
    // providers: [
    //     { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    // ],
})
export class SharedModule {}